import { ContextualContentBox } from "@foodpilot/foods";
import { HTMLBox } from "../HTMLBox/HTMLBox";

type HeadingHelperTextBoxProps = {
    value: string | undefined;
};
export const HeadingHelperTextBox = (props: HeadingHelperTextBoxProps) => {
    const { value } = props;

    let trimmedValue = value?.trim();
    if (!trimmedValue || trimmedValue === "<p> </p>") {
        return null;
    }

    return (
        <ContextualContentBox size="small">
            <HTMLBox value={trimmedValue} centerImages />
        </ContextualContentBox>
    );
};
